import * as React from 'react'
import Skeleton from 'react-loading-skeleton'
import { times } from 'lodash';

function HelpSkeleton(): React.ReactElement {
  function getRandom(min, max): number {
    return Math.random() * (max - min) + min;
  }
  return (
    <div className="help-center__skeleton">
      <div className="ml-1">
        <Skeleton count={1} width={`${55}%`} />
      </div>
      <ul>
        {times(getRandom(3, 7), (index) =>
          <li key={`skeleton-line-${index}`}><Skeleton count={1} width={`${getRandom(20, 35)}%`}/></li>
        )}
      </ul>
    </div>
  )
}

export default React.memo(HelpSkeleton);
